import Vue from 'vue';
import {UserRoleEnum} from '@/enums/userRolesEnum';
import format from 'date-fns/format'
import InvoiceWeekCard from './cards/InvoiceWeekCard';
import CustomMonthPicker from '@/components/calendarShifts/calendarShiftsComponents/CustomMonthPicker.vue';
import {convertDateToUTC} from '@/utils/dateUtil';
import FilterComponent from '../../componentsReusable/FilterComponent.vue';
import * as InvoiceFilterEnums from '@/enums/invoiceFilterEnums';
import FacilityPaidInvoices from './cards/facilityPaidInvoices/FacilityPaidInvoicesCard';
import FacilityInvoicesToPay from './cards/facilityInvoicesToPay/FacilityInvoicesToPayCard';
import CreateSpecialInvoice from "@/components/invoices/special/CreateSpecialInvoice";

const SUNDAY = 0;
const MONDAY = 1;

const filterTypes = {
  [InvoiceFilterEnums.FACILITY_FILTER_TYPE]: {
    id: InvoiceFilterEnums.FACILITY_FILTER_TYPE,
    name: "Facility",
    isSelected: true,
    searchAPI: '/api/facilities/search?facilityNameLike=',
    conditionResponseData: function (responseData: any) {
      return responseData.map((responseObject: any) => {
        responseObject.filterTypeId = 1;
        return responseObject;
      });
    }
  },
  [InvoiceFilterEnums.STATUS_FILTER_TYPE]: {
    id: InvoiceFilterEnums.STATUS_FILTER_TYPE,
    name: "Invoice Status",
    isSelected: false,
    searchEnum: InvoiceFilterEnums.statuses
  }
};

const invoiceIdFilterTypes = {
  '1': {
    id: '1',
    name: 'Invoice ID',
    isSelected: true,
    searchAPI: '/api/invoices/search?invoiceIdLike=',
    conditionResponseData: function (responseData: any) {
      return responseData.map((responseObject: any) => {
        responseObject.filterTypeId = 1;
        return responseObject;
      });
    }
  }
};

export default Vue.extend({
  name: 'Invoices',
  components: {
    InvoiceWeekCard,
    CustomMonthPicker,
    FilterComponent,
    FacilityPaidInvoices,
    FacilityInvoicesToPay,
    CreateSpecialInvoice
  },
  filters: {
    headerFormat (dateISO: string): string {
      return format(dateISO, 'MMM YYYY');
    },
    monthFormat (date: Date): string {
      return format(date, 'MMM');
    }
  },
  data () {
    const today = new Date();
    return {
      showActionsDropdown: false,
      isAuthorizedAdminPortalUser: false,
      isAuthorizedFacilityPortalUser: false,
      weeks: [] as any[],
      monthStart: new Date(today.getFullYear(), today.getMonth(), 1),
      filterTypes: filterTypes,
      invoiceIdFilterTypes: invoiceIdFilterTypes,
      filtersSelected: [] as any[],
      showSpecialInvoiceCreateModal: false
    };
  },
  async created () {
    this.isAuthorizedAdminPortalUser = this.$store.getters['user/hasRole']([
      UserRoleEnum.MANAGER,
      UserRoleEnum.ACCOUNTANT
    ]);
    this.isAuthorizedFacilityPortalUser = this.$store.getters['user/hasRole']([
      UserRoleEnum.FACILITY_CONTACT
    ]);
    if (this.isAuthorizedAdminPortalUser) {
      this.setWeeksForMonth();
    }
  },
  methods: {
    toggleActionsDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },
    monthChanged(newDate: any) {
      this.monthStart = convertDateToUTC(newDate);
      this.setWeeksForMonth();
    },
    setWeeksForMonth() {
      if (!this.monthStart) {
        return;
      }
      const shiftStart = new Date(this.monthStart.getTime());
      let toSet;
      /*
       * Sunday we need to set -5 to get to Monday
       * Monday we need to set 1 to stay on the first day of the month (0 is the day before the 1st day of the month)
       * Otherwise we need to subtract 2 and set that in the past.
       * Subtract 2 because getDay() is 0-based with Sunday == 0 and calling setDate() with 0 means the day before the first day of the month
       * So getDay() when Tuesday is the 1st of the Month returns 2 but we need to call setDate with 0 to go to Monday
       */
      if (shiftStart.getDay() === SUNDAY) {
        toSet = -5;
      } else if (shiftStart.getDay() === MONDAY) {
        toSet = 1;
      } else {
        toSet = -1 * (shiftStart.getDay() - 2);
      }
      shiftStart.setDate(toSet);
      this.weeks = [];
      do {
        const startDate = new Date(shiftStart);
        const endDate = new Date(shiftStart);
        endDate.setDate(endDate.getDate() + 6);
        const week = {startDate: startDate, endDate: endDate} as any;
        this.weeks.push(week);
        shiftStart.setDate(shiftStart.getDate() + 7);
      } while (shiftStart.getMonth() === this.monthStart.getMonth());
    },
    gotoProviderCart() {
      this.$router.push({name: 'ProviderPayments'});
    },
    filterChanged (filters: any[]) {
      this.filtersSelected = filters;
    },
    invoiceIdFilterChanged (filters: any[]) {
      if (filters.length > 0) {
        this.$router.push({ name: 'Invoice', params: { invoiceId: filters[0].name }});
      }
    },
    async goToMerge() {
      this.$router.push(
        {
          name: 'PreInvoiceMerge'
        });
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoices/Invoices.ts